import { Linktrainrelaymixer } from '@linktivity/eticketportal';

type OrderLocaleLanguage =
  Linktrainrelaymixer.GetOrderDetailsCommonLocaleLanguageEnum;
const OrderLocaleLanguage =
  Linktrainrelaymixer.GetOrderDetailsCommonLocaleLanguageEnum;

export const getOrderLocaleLanguage = (
  language: string
): OrderLocaleLanguage => {
  const localeMap: Record<string, OrderLocaleLanguage> = {
    en: OrderLocaleLanguage.English,
    ja: OrderLocaleLanguage.Japanese,
    ko: OrderLocaleLanguage.Korean,
    zh: OrderLocaleLanguage.Chinese,
    zt: OrderLocaleLanguage.Chinese
  };

  return localeMap[language] || OrderLocaleLanguage.Japanese;
};
